var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1C2033",
    width: 52,
    height: 52,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6016 34.5996C25.6016 34.5996 29.6016 30.5996 29.6016 25.5996C29.6016 20.5996 25.6016 16.5996 20.6016 16.5996C15.6016 16.5996 11.6016 20.5996 11.6016 25.5996C11.6016 30.5996 15.7016 34.5996 20.6016 34.5996ZM20.6016 18.5996C24.5016 18.5996 27.6016 21.6996 27.6016 25.5996C27.6016 29.4996 24.5016 32.5996 20.6016 32.5996C16.7016 32.5996 13.6016 29.4996 13.6016 25.5996C13.6016 21.6996 16.8016 18.5996 20.6016 18.5996Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 39C13.9 39 7.39995 41.4 2.29995 45.6C1.89995 46 1.79995 46.6 2.19995 47C2.59995 47.4 3.19995 47.5 3.59995 47.1C8.29995 43.1 14.3 40.9 20.6 40.9C26.9 40.9 32.8999 43.1 37.5999 47.1C37.7999 47.3 38 47.3 38.2 47.3C38.5 47.3 38.8 47.2 39 46.9C39.4 46.5 39.3 45.8 38.9 45.5C33.8 41.4 27.4 39 20.6 39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9984 37.9992H56.6984V33.6992C56.6984 33.0992 56.2984 32.6992 55.6984 32.6992C55.0984 32.6992 54.6984 33.0992 54.6984 33.6992V37.9992H50.3984C49.7984 37.9992 49.3984 38.3992 49.3984 38.9992C49.3984 39.5992 49.7984 39.9992 50.3984 39.9992H54.6984V44.2992C54.6984 44.8992 55.0984 45.2992 55.6984 45.2992C56.2984 45.2992 56.6984 44.8992 56.6984 44.2992V39.9992H60.9984C61.5984 39.9992 61.9984 39.5992 61.9984 38.9992C61.9984 38.3992 61.5984 37.9992 60.9984 37.9992Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserAlt);
export default __webpack_public_path__ + "static/media/add-user-alt.270a9c916c313bbdd9ad3a64eada9265.svg";
export { ForwardRef as ReactComponent };